module.exports = __webpack_public_path__ + "static/abstract2-9a914875297041450b03672383ae71b1.jpg";